import { MyArticlesIcon } from '@mybridge/icons/MyArticles';
import { MyCircleIcon } from '@mybridge/icons/MyCircle';
import { MyEventsIcon } from '@mybridge/icons/MyEvents';
import { MyPagesIcon } from '@mybridge/icons/MyPages';
import { MyTeamsIcon } from '@mybridge/icons/MyTeams';
import { Divider, HStack, Link, Stack, Text } from '@mybridge/ui';

import { forwardRef, useMemo } from 'react';
export const MyProfileLinksList = forwardRef(({ ...props }, ref) => {
  const menuLinks = useMemo(
    () => [
      {
        title: 'myCircle',
        icon: <MyCircleIcon width="20" height="20" />,
        link: '/profile/network',
      },
      {
        title: 'myEvents',
        icon: <MyEventsIcon width="20" height="20" />,
        link: '/myevents',
      },
      {
        title: 'myTeams',
        icon: <MyTeamsIcon width="20" height="20" />,
        link: '/teams',
      },
      {
        title: 'myPages',
        icon: <MyPagesIcon width="20" height="20" />,
        link: '/settings/pages',
      },
      {
        title: 'myArticles',
        icon: <MyArticlesIcon width="20" height="20" />,
        link: '/articles',
      },
    ],
    []
  );
  return (
    <>
      <Stack spacing={0}>
        {menuLinks?.map((ml, mlIndex) => (
          <>
            {mlIndex > 0 ? <Divider /> : ''}
            <Link
              p={2}
              py={4}
              _hover={{ bg: 'blackAlpha.100' }}
              href={ml?.link}
              key={mlIndex}
            >
              <HStack>
                {ml?.icon}
                <Text>{ml?.title}</Text>
              </HStack>
            </Link>
          </>
        ))}
      </Stack>
    </>
  );
});
